import { render, staticRenderFns } from "./AppLogout.vue?vue&type=template&id=848c505e&scoped=true&"
import script from "./AppLogout.vue?vue&type=script&lang=js&"
export * from "./AppLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c505e",
  null
  
)

export default component.exports